import oneMoney from "../../../images/AG Dashboard/oneMoney.png";
import finvu from "../../../images/AG Dashboard/finvu.png";
import nadl from "../../../images/AG Dashboard/nadl.png";
import anumati from "../../../images/anumati.png";
import Carousel from "react-multi-carousel";
import camsfinserv from "../../../images/AG Dashboard/camsfinserv.png";
import protean from "../../../images/AG Dashboard/protean.png";
import "react-multi-carousel/lib/styles.css";

function WithStyles({ image }) {
  return (
    <div className=" flex items-center justify-center  w-full h-full">
      <img
        width={image === protean || image === camsfinserv ? 70 : 55}
        alt="consent"
        src={image}
        className=" object-scale-down object-center "
      />
    </div>
  );
}
function SlideImageCard() {
  const images = [anumati, oneMoney, finvu, nadl, camsfinserv, protean];

  return (
    <div className=" min-w-[198px] h-full px-4 flex items-center sm:flex-col md:flex-row">
      <Carousel
        arrows={false}
        containerClass={`w-[64px] h-[64px]`}
        additionalTransfrom={0}
        autoPlay
        autoPlaySpeed={500}
        centerMode={false}
        className=""
        dotListClass=""
        draggable
        focusOnSelect={false}
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 1,
            partialVisibilityGutter: 40,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0,
            },
            items: 1,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464,
            },
            items: 2,
            partialVisibilityGutter: 30,
          },
        }}
        rewind
        rewindWithAnimation={true}
        showDots={false}
        sliderClass=""
        swipeable
        transitionDuration={1000}
      >
        {images.map((image, index) => (
          <WithStyles key={index} image={image} />
        ))}
      </Carousel>

      <div className=" ml-4 flex flex-col h-[57px] justify-between font-semibold ">
        <p className=" lg:text-sm md:text-xs text-[#848484]">provider</p>
        <p className=" lg:text-2xl md:text-sm">6</p>
      </div>
    </div>
  );
}

export default SlideImageCard;
